/**
 * @generated SignedSource<<8076ec05efcc56f74d940bf38add16f0>>
 * @relayHash ebafbd06056b37edff6ee5f7a1bd4c11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2cd986d7c09544f71d1ec0fe65382b85fbe26437479132c5ef7b7d9556c6ab1f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFormsQuery } from './uiFormsQuery.graphql';

const node: PreloadableConcreteRequest<uiFormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2cd986d7c09544f71d1ec0fe65382b85fbe26437479132c5ef7b7d9556c6ab1f",
    "metadata": {},
    "name": "uiFormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
